import { DeleteOutline, DownloadOutlined } from "@mui/icons-material";
import { Table, message } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { getUserList, getUserInfo, getClientid } from "redux/selectors";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import { LEAVE_ICON, STATUS_CODE } from "common/Constants";
import { setProfilePic, setUserList, setSupervisorList } from "redux/actions";
import download from "downloadjs";
import advancedFormat from "dayjs/plugin/advancedFormat";


const MyCV = ({ userInfo, userList, ClientId, updateUserList, saveSupervisorList, saveProfilePic }) => {
  const [filteruser, setFilterUser] = useState({});
  const [isDocumentUpload, setIsDocumentupload] = useState(false);
  const [docLoader, setDocLoader] = useState(false);
  const [isLoadingDocuments, toggleLoadingDocuments] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewURL, setPreviewURL] = useState("");


  useEffect(() => {
    const filteredUser =
      userList?.filter((item) => item?.userid === userInfo?.userid)[0];

    setFilterUser(filteredUser);


  }, [userList]);
  const data = [
    {
      doucumentPath: "insyts-bdo-documents-live/documents/BDIX4EW",
      fileSize: "",
      name: "Aadarsh CV.pdf",
      documentId: 225,
      documentName: "Aadarsh CV.pdf",
      type: "application/pdf",
      s3BucketObjectName: "aadarsh.shah_1733490696086_Aadarsh_CV.pdf",
      createdon: "2024-12-06",
    },
  ];

  const fetchMasterData = async (fetch_master_data) => {
    const { code, userList, supervisorList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      {
        fetch_master_data,
      }
    );

    if (code === STATUS_CODE.SUCCESS) {
      updateUserList(userList);
      saveSupervisorList(supervisorList);
      let profileUpdate = userList?.filter(
        (val) => val?.userid === userInfo.userid
      );
      if (profileUpdate?.length !== 0) {
        saveProfilePic(profileUpdate[0]?.profileurl);
      }
    }
  };

  const deleteIdentityInfo = async (id, type) => {
    setIsDocumentupload(true);
    const { code } = await CALL_API(
      `upload-document/${ClientId}/${id}`,
      "delete",
      {
        documentName: type,
        userId: filteruser?.userid,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      await fetchMasterData();
      message.success("Document has been Deleted");
    }
    setIsDocumentupload(false);
  };

  const handleMenuClick = async (id, type, document) => {
    try {
      // setPrreviewType();
      setDocLoader(true);
      const preview = document?.split(".")?.pop();
      toggleLoadingDocuments(true);
      const { code, url } = await CALL_API(
        `document-list/${ClientId}`,
        "post",
        {
          method: "preview-identity-document",
          documentId: id,
          identityName: type,
          userId: filteruser?.userid,
        }
      );
      if (code === STATUS_CODE.SUCCESS) {
        if (
          preview === "jpg" ||
          preview === "png" ||
          preview === "jpeg" ||
          preview === "svg" ||
          preview === "pdf" ||
          preview === "doc" ||
          preview === "docx" ||
          preview === "ppt" ||
          preview === "pptx"
        ) {
          setIsPreviewModalOpen(true);
          setPreviewURL(url?.publicurl);
        } else {
          download(url);
        }
        setDocLoader(false);
      } else {
        message.error("Something went wrong!! Please try again.");
      }
    } catch (error) {
      console.error("Download error:", error);
      message.error("Download failed. Please try again.");
    } finally {
      toggleLoadingDocuments(false);
    }
  };

  const cvInfoColumns = [
    {
      title: "File Name",
      dataIndex: "documentName",
      key: "name",
      width: 160,   // ✅ now this WILL apply
      render: (name) => (
        <div
          title={name}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </div>
      ),
    },


    {
      title: "File type",
      dataIndex: "filetype",
      key: "filetype",
      width: 130,
      render: (value) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {value || "-"}
        </span>
      ),
    },
    {
      title: "CV type",
      dataIndex: "cvtype",
      key: "cvtype",
      width: 110,
      render: (value) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {value === "long" ? "Long" : value === "short" ? "Short" : "-"}
        </span>
      ),
    },
    {
      title: "Date Added",
      dataIndex: "createdon",
      key: "createdon",
      width: 150,
      render: (date) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {date ? dayjs(date).format("Do MMM YYYY") : "-"}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      render: (_, record) => (
        <>
          <DownloadOutlined
            style={{ cursor: "pointer", marginRight: 12 }}
            onClick={() => handleMenuClick(record?.documentId, "cv", record?.documentName)}
          />
          <DeleteOutline
            style={{ cursor: "pointer" }}
            onClick={() => deleteIdentityInfo(record?.documentId, "cv")}
          />
        </>
      ),
    },
  ];



  let cvList = filteruser?.cv || [];

  console.log(filteruser, "filteruser")
  console.log(cvList, "cvList")

  return (
    <Table
      dataSource={cvList}
      columns={cvInfoColumns}
      rowKey="role_id"
      pagination={false}
      tableLayout="fixed"          // 🔥 REQUIRED
      scroll={{ x: 750, y: 300 }}  // 🔥 numeric value REQUIRED
    />



  );
};

const mapStateToProps = (state) => ({
  userList: getUserList(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),


});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveSupervisorList: setSupervisorList,
      updateUserList: setUserList,
      saveProfilePic: setProfilePic,

    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MyCV);
